import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('elearning_package');

export default {
    state: {
        ...EdverumTable.search.state,
        ...EdverumTable.created.state,
        standardFilter: null,
    },

    getters: {
        ...EdverumTable.search.getters,

        hasStandardFilter(state) {
            return Boolean(state.standardFilter);
        },

        standardFilter(state) {
            return state.standardFilter;
        },
    },

    actions: {
        ...EdverumTable.created.actions,
        reset: collectionHelpers.actions.reset('ElearningPackages'),
    },

    mutations: {
        ...EdverumTable.search.mutations,
        ...EdverumTable.created.mutations,
        SET_STANDARD_FILTER(state, standard) {
            state.standardFilter = standard;
        },
        CLEAR_STANDARD_FILTER(state) {
            state.standardFilter = null;
        },
    },
};
